export default {
    text_1: "Vlastní barvy nabídky",
    text_2: "Vlastní barvy nabídky",
    text_3: "Nastavení vlastní barvy",
    text_4: "Personalizuj své nabídky a použij vlastní barvy, aby ladily s tvým logem či firemními barvami. Barvy můžeš kdykoli měnit.",
    text_5: "Uložit",
    text_6: "Vyber si svoji barevnou kombinaci",
    text_7: "nebo použij vlastní barvu",
    text_8: "Tvoje cenová nabídka bude vypadat takto:",
    text_9: "Barva nabídky byla uložena."
}
